import {
    FirstCommonHeaders,
    LastCommonHeaders,
} from './CommonHeaders.settings.js'

import {
    BattlesCountColumnTooltipContent,
    DamageColumnTooltipContent,
    DaysInClanColumnTooltipContent,
    ExperienceColumnTooltipContent,
    PersonalRatingColumnTooltipContent,
    WinRateColumnTooltipContent,
} from '../Statistics/tooltips'

export default [
    ...FirstCommonHeaders,
    {
        isSortable: true,
        icon: 'rating',
        key: 'personal_rating',
        tooltipId: 'members-table-column-tooltip',
        tooltipTip: PersonalRatingColumnTooltipContent.tip,
    },
    {
        isSortable: true,
        icon: 'battles',
        key: 'battles_count',
        tooltipId: 'members-table-column-tooltip',
        tooltipTip: BattlesCountColumnTooltipContent.tip,
    },
    {
        isSortable: true,
        icon: 'wins',
        key: 'wins_percentage',
        tooltipId: 'members-table-column-tooltip',
        tooltipTip: WinRateColumnTooltipContent.tip,
    },
    {
        isSortable: true,
        icon: 'avg-exp',
        key: 'experience_per_battle',
        tooltipId: 'members-table-column-tooltip',
        tooltipTip: ExperienceColumnTooltipContent.tip,
    },
    {
        isSortable: true,
        icon: 'avg-damage',
        key: 'damage_per_battle',
        tooltipId: 'members-table-column-tooltip',
        tooltipTip: DamageColumnTooltipContent.tip,
    },
    {
        isSortable: true,
        icon: 'days',
        key: 'days_in_clan',
        tooltipId: 'members-table-column-tooltip',
        tooltipTip: DaysInClanColumnTooltipContent.tip,
    },
    ...LastCommonHeaders,
]



// WEBPACK FOOTER //
// ./containers/ClanManagement/components/MembersTable/StatisticsHeaders.settings.js